import { render, staticRenderFns } from "./ThemeSavePopup.vue?vue&type=template&id=5a6036c6&scoped=true&"
import script from "./ThemeSavePopup.vue?vue&type=script&lang=js&"
export * from "./ThemeSavePopup.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSavePopup.vue?vue&type=style&index=0&id=5a6036c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6036c6",
  null
  
)

export default component.exports